import { accordion } from './accordion';
import { toggleHamburger } from './toggleHamburger';
toggleHamburger('js-hamburger', 'js-spmenu', 768);

accordion();

const topSliderElement = document.querySelector('.js-popular-slider');
const topPurposeElement = document.querySelector('.js-purpose-slider');

if (topSliderElement) {
  const topPopularSlider = new Splide(topSliderElement, {
    type: 'loop',
    pagination: true,
    rewind: true,
    focus: 'center',
    autoWidth: true,
    gap: '152px',
  }).mount();

  topPopularSlider.on('resize', () => {
    topPopularSlider.refresh();
  });
}

if (topPurposeElement) {
  const topPurposeSplide = new Splide(topPurposeElement, {
    breakpoints: {
      768: {},
    },
    type: 'loop',
    pagination: true,
    rewind: true,
    focus: 'center',
    autoWidth: true,
    gap: '30px',
    perMove: 1,
    flickMaxPages: 1,
    flickPower: 50,
  }).mount();

  topPurposeSplide.on('resize', () => {
    topPurposeSplide.refresh();
  });
}

// 見出しアニメーション
function onScroll() {
  const viewportHeight = window.innerHeight;
  const elements = document.querySelectorAll('.js-viewport-animation');
  // const elementsShip = document.querySelectorAll('.js-top-ship');

  elements.forEach((el) => {
    const rect = el.getBoundingClientRect();
    if (rect.top <= viewportHeight * 0.85) {
      el.classList.add('_animation');
    }
  });
}
window.addEventListener('scroll', onScroll);
window.addEventListener('DOMContentLoaded', onScroll);

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
    anchor.addEventListener('click', function (e) {
      e.preventDefault(); // デフォルトの動作をキャンセル

      // href属性から、リンク先の要素のIDを取得
      let targetId = this.getAttribute('href');
      let targetElement = document.querySelector(targetId);

      if (targetElement) {
        // 要素までのオフセット位置を取得（上部の余白を考慮）
        let offsetTop =
          targetElement.getBoundingClientRect().top + window.pageYOffset - 100;

        // スムーズスクロールを実行
        window.scrollTo({
          top: offsetTop,
          behavior: 'smooth',
        });
      }
    });
  });
});
